export default "__VITE_ASSET__23236ce9__"